import React from 'react';
import { Trash2 } from 'lucide-react';

const ModalConfirm = ({ aberto, titulo, mensagem, aoConfirmar, aoCancelar }) => {
  if (!aberto) return null;
  return (
    <div className="fixed inset-0 bg-black/90 z-[2500] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in">
      <div className="bg-slate-900 border-2 border-slate-800 p-8 rounded-[40px] max-w-sm w-full text-center space-y-6 shadow-2xl">
        <div className="bg-red-500/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto text-red-500">
          <Trash2 size={32} />
        </div>
        <div>
          <h3 className="text-xl font-black text-white tracking-tighter">{titulo}</h3>
          <p className="text-slate-400 text-xs mt-2 font-bold leading-relaxed">{mensagem}</p>
        </div>
        <div className="flex gap-3 pt-2">
          <button onClick={aoCancelar} className="flex-1 bg-slate-800 py-4 rounded-2xl font-black text-[10px] tracking-widest text-slate-400 hover:text-white transition-colors">Cancelar</button>
          <button onClick={aoConfirmar} className="flex-1 bg-red-600 py-4 rounded-2xl font-black text-[10px] tracking-widest text-white hover:bg-red-500 transition-colors">Confirmar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;